// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"26221":"0e70f9fe419da3804095","63598":"5097533d921f1eea007d"}[chunkId] + ".css";
};